export default function Move() {
  return (
    <div className="move">
      <svg>
        <g>
          <line x1="10%" y1="50%" x2="90%" y2="50%"></line>
          <line x1="10%" y1="50%" x2="20%" y2="40%"></line>
          <line x1="10%" y1="50%" x2="20%" y2="60%"></line>
          <line x1="80%" y1="40%" x2="90%" y2="50%"></line>
          <line x1="80%" y1="60%" x2="90%" y2="50%"></line>
          <line x1="50%" y1="10%" x2="50%" y2="90%"></line>
          <line x1="50%" y1="10%" x2="40%" y2="20%"></line>
          <line x1="50%" y1="10%" x2="60%" y2="20%"></line>
          <line x1="40%" y1="80%" x2="50%" y2="90%"></line>
          <line x1="60%" y1="80%" x2="50%" y2="90%"></line>
        </g>
      </svg>
    </div>
  );
}